export const colors = [
  "#1C77FF",
  "#FF5D3D",
  "#67C771",
  "#FF1CBF",
  "#FF4848",
  "#512D6D",
  "#28FFBF",
  "#F7E6AD",
];
